import { useState } from "react"
import { navigate } from "gatsby"
import { fetchESIAUrl } from "./helper"
import { pushToDL } from "../../helpers/WatcherDL/utils/helper"
import { PlacementsESIA } from "./types"

type RequestStatus = "idle" | "loading" | "error"

interface UseESIAHook {
  requestStatus: RequestStatus
  handleESIAClick: (placement: "main" | "calculator") => Promise<void>
  isButtonDisabled: boolean
}

const useESIA = (productName: string): UseESIAHook => {
  const [requestStatus, setRequestStatus] = useState<RequestStatus>("idle")
  const [isButtonDisabled, setButtonDisabled] = useState(false)

  const handleESIAClick = async (placement: PlacementsESIA) => {
    pushToDL({
      event: "buttonClick",
      eventCategory: "click_block",
      name: "enter_esia",
      eventLabel: globalThis?.location?.href,
      placement,
    })

    sessionStorage.setItem("fromPageBeforeESIA", window.location.href)
    sessionStorage.setItem("productNameforESIA", productName)

    setRequestStatus("loading")
    setButtonDisabled(true)

    try {
      const ESIAUrl = await fetchESIAUrl(productName, placement)

      if (!ESIAUrl) {
        throw new Error("ESIA URL is empty or undefined")
      }

      window.location = ESIAUrl
    } catch (error) {
      setRequestStatus("error")
      console.error("Failed to fetch ESIA URL:", error)

      navigate("/error-technical/", {
        state: {
          from: globalThis?.location?.href,
          errorInfo: `fetchESIA, error: ${error instanceof Error ? error.message : String(error)}`,
        },
      })
    } finally {
      setRequestStatus("idle")
      setButtonDisabled(false)
    }
  }

  return {
    isButtonDisabled,
    requestStatus,
    handleESIAClick,
  }
}

export default useESIA
